export const enum ApiCredentialsServiceEnum {
    PROM = 'prom',
    KASTA = 'kasta',
    HOROSHOP = 'horoshop',
    SHOP_EXPRESS = 'shop-express',
    ROZETKA = 'rozetka',
    EPICENTR = 'epicentr',
    WOOCOMMERCE = 'woocommerce',
    MAUDAU = 'maudau',
    INTEL_TELE = 'intel-tele',
    EVA = 'eva',
    ALLO = 'allo',
    NOVAPOST = 'novapost',
}
